import { DatePicker, DateView } from '@mui/x-date-pickers'
import dayjs, { Dayjs } from 'dayjs'
import { CSSProperties } from 'react'
import { Control, Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

interface Props {
  name: string
  control?: Control<any>
  format?: string
  openTo?: DateView
  views?: DateView[]
  style?: CSSProperties
  canDelete?: boolean
}

const FORMAT = 'YYYY-MM-DD'

export default function KumocanDatePicker(props: Props) {
  const { t } = useTranslation('common')
  const {
    name,
    control,
    format = 'YYYY/MM/DD (dd)',
    openTo = 'day',
    views = ['year', 'month', 'day'],
    style = {},
    canDelete = false,
  } = props

  const localeText = {
    okButtonLabel: t('picker.ok'),
    cancelButtonLabel: t('picker.cancel'),
    clearButtonLabel: t('picker.clear'),
    todayButtonLabel: t('picker.today'),
  }

  // forでネスト構造にアクセスして、初期値を取得
  let defaultValue = control?._defaultValues
  name.split('.').forEach((x) => {
    defaultValue = defaultValue?.[x]
  })

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue || null}
      render={({ field }) => {
        const { value, onChange, ref } = field
        // ここで「おかしな値」を判定する（例: 0001-01-01 なら null）
        let sanitizedValue: Dayjs | null = value ? dayjs(value) : null
        if (sanitizedValue?.format(FORMAT) === '0001-01-01') {
          sanitizedValue = null
        }
        return (
          <DatePicker
            localeText={localeText}
            value={sanitizedValue}
            onChange={(dateValue) => {
              onChange(dateValue)
            }}
            inputRef={ref}
            format={format}
            openTo={openTo}
            views={views}
            slotProps={
              canDelete
                ? {
                    field: { clearable: true },
                  }
                : {}
            }
            sx={style}
            className="datePicker"
          />
        )
      }}
    />
  )
}
